import React from 'react'
import cx from 'classnames'
import styles from './BoldButton.module.scss'

type BoldButtonProps = {
  label?: React.ReactNode
  icon?: string
  isIconFirst?: boolean
  isPrimary?: boolean
  width?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
  className?: string
}

export const BoldButton = ({
  label,
  icon,
  isIconFirst = false,
  isPrimary = true,
  width = 'fit-content',
  onClick,
  className,
}: BoldButtonProps) => {
  const iconImg = <img src={icon} alt="button icon" />

  return (
    <div
      className={cx(className, styles.container, {
        [styles.primary]: isPrimary,
      })}
      style={{ [`width`]: width }}
      onClick={onClick}
    >
      {isIconFirst && icon ? iconImg : null}
      <span className={styles.label}>{label}</span>
      {!isIconFirst && icon ? iconImg : null}
    </div>
  )
}
